var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBetaEnv)?_c('div',{staticClass:"testAnnouncement",class:_vm.focused ? 'bg-glass disabled' : 'normal'},[_c('div',[_vm._v("当前为内测版，新功能会先发布至此，数据与正式版互通。如遇问题，请在内测群反馈。")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }